import { useState } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";
import session from "../../SessionHandler/session-helper";
import Container from "../UI/Container";
import Bimestre from "./Bimestre";
import DiaCalendarioMenu from "./DiaCalendario/DiaCalendarioMenu";
import { DIA_LETIVO_EXTRA as CONFIG_DIA_LETIVO_EXTRA, DIA_NAO_LETIVO as CONFIG_DIA_NAO_LETIVO } from "./DiaCalendario/diaCalendarioConfig";

const BIMESTRE = "bimestre";
const DIA_LETIVO_EXTRA = "diaLetivoExtra";
const DIA_NAO_LETIVO = "diaNaoLetivo";

const BimestreContainerMenu = () => {
  const [aba, setAba] = useState(BIMESTRE);

  return (
    <Container>
      <Box mb={1}>
        <Typography variant="h6">Calendário Escolar</Typography>
        <Typography variant="body2" color="text.secondary">
          Bimestres, dias letivos extras e dias não letivos do ano letivo {session.getAnoLetivo()}.
        </Typography>
      </Box>

      <Tabs
        value={aba}
        onChange={(event, value) => setAba(value)}
        variant="scrollable"
        allowScrollButtonsMobile
        sx={{ mb: 3, borderBottom: 1, borderColor: "divider" }}
      >
        <Tab value={BIMESTRE} label="Bimestres" />
        <Tab value={DIA_LETIVO_EXTRA} label="Dias Letivos Extras" />
        <Tab value={DIA_NAO_LETIVO} label="Dias Não Letivos" />
      </Tabs>

      {aba === BIMESTRE && <Bimestre />}
      {aba === DIA_LETIVO_EXTRA && <DiaCalendarioMenu key={DIA_LETIVO_EXTRA} config={CONFIG_DIA_LETIVO_EXTRA} />}
      {aba === DIA_NAO_LETIVO && <DiaCalendarioMenu key={DIA_NAO_LETIVO} config={CONFIG_DIA_NAO_LETIVO} />}
    </Container>
  );
};

export default BimestreContainerMenu;
